/* Waïloa – fiche produit : galerie mobile (points + compteur), message de réassort + alerte e-mail,
   estimation de livraison, barre d'achat collante unique + feuille de tailles, description courte repliable,
   apparition douce des sections.
   Chargé en defer, sans dépendance. */
(function () {
  if (window.wlPdpInit) return;
  window.wlPdpInit = true;

  /* Galerie mobile : points + compteur */
  document.addEventListener('scroll', function (e) {
    var box = e.target;
    if (!box || !box.classList || !box.classList.contains('product__img-box')) return;
    var main = box.closest('.wl-pdp-main');
    var dots = main && main.querySelector('[data-wl-gal-dots]');
    if (!dots || !box.clientWidth) return;
    var i = Math.round(box.scrollLeft / box.clientWidth);
    var cur = dots.querySelector('[data-wl-gal-cur]');
    if (cur) cur.textContent = i + 1;
    dots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
  }, true);

  /* Message de réassort : visible quand le bouton d'achat est indisponible */
  function norm(t) { return String(t || '').replace(/[\s ]+/g, '').toLowerCase(); }
  function mainBtn() { return document.querySelector('.wl-pdp-main form.main-product-form [data-atc-wrapper]'); }
  function variantId() {
    var f = document.querySelector('.wl-pdp-main form.main-product-form [name="id"]');
    var m = /[?&]variant=(\d+)/.exec(location.search);
    return (f && f.value) || (m && m[1]) || '';
  }
  /* Formulaire d'alerte : suit la variante choisie */
  var bisMap = null;
  function bis(box) {
    var form = box.querySelector('form.wl-bis');
    if (!form) return;
    if (!bisMap) {
      try { bisMap = JSON.parse((box.querySelector('[data-wl-bis-map]') || {}).textContent || '[]'); } catch (e) { bisMap = []; }
    }
    var id = variantId();
    var cur = form.querySelector('[data-wl-bis-id]');
    if (!id || !cur || cur.value === id) return;
    var v = null;
    for (var i = 0; i < bisMap.length; i++) if (String(bisMap[i].id) === id) v = bisMap[i];
    function set(sel, val) { var el = form.querySelector(sel); if (el) el.value = val; }
    set('[data-wl-bis-id]', id);
    if (v) { set('[data-wl-bis-title]', v.t || ''); set('[data-wl-bis-sku]', v.s || ''); }
    var link = form.querySelector('[data-wl-bis-link]');
    if (link) link.value = link.value.replace(/variant=\d+/, 'variant=' + id);
    var ret = form.querySelector('[data-wl-bis-return]');
    if (ret) ret.value = ret.value.replace(/variant=\d+/, 'variant=' + id);
    /* Confirmation affichée pour une autre taille : on rouvre le formulaire */
    var ok = form.querySelector('[data-wl-bis-ok]');
    if (ok) {
      var same = ok.getAttribute('data-wl-bis-ok') === id;
      ok.hidden = !same;
      form.querySelectorAll('[data-wl-bis-row],[data-wl-bis-note]').forEach(function (el) { el.hidden = same; });
    }
  }
  function stock() {
    var box = document.querySelector('.wl-pdp-main [data-wl-stock]');
    var btn = mainBtn();
    if (!btn) return;
    if (box) {
      var so = norm(box.getAttribute('data-soldout'));
      box.hidden = !(btn.disabled && (!so || norm(btn.textContent).indexOf(so) > -1));
      bis(box);
    }
    var dl = document.querySelector('.wl-pdp-main [data-wl-deliv]');
    if (dl) dl.hidden = !!btn.disabled || (dl.getAttribute('data-mode') === 'stock' && !dl.getAttribute('data-ready'));
  }

  /* Estimation de livraison (date de LIVRAISON, pas d'expédition) :
     aujourd'hui (date de Paris) + N jours ouvrés, hors samedi/dimanche, jours fériés français et jours fermés réglés.
     Pas d'heure limite : jeudi 18 h 36 + 3 → mardi ; vendredi + 3 → mercredi. */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function addDays(d, n) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n)); }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, mo - 1, da));
  }
  var holCache = {};
  function holidays(y) {
    if (holCache[y]) return holCache[y];
    var s = {};
    ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].forEach(function (md) { s[y + '-' + md] = 1; });
    var e = easter(y);
    [1, 39, 50].forEach(function (n) { s[key(addDays(e, n))] = 1; }); /* lundi de Pâques, Ascension, lundi de Pentecôte */
    return (holCache[y] = s);
  }
  function parisToday(now) {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(now).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    } catch (e) { p = {}; }
    if (!p.year) p = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    return new Date(Date.UTC(p.year, p.month - 1, p.day));
  }
  function deliveryDate(now, days, sat, off) {
    function open(d) {
      var w = d.getUTCDay();
      if (w === 0 || (w === 6 && !sat)) return false;
      var k = key(d);
      return !holidays(d.getUTCFullYear())[k] && off.indexOf(k) < 0;
    }
    var d = parisToday(now);
    for (var i = 0; i < days;) { d = addDays(d, 1); if (open(d)) i++; }
    return d;
  }
  function delivery() {
    var el = document.querySelector('.wl-pdp-main [data-wl-deliv][data-mode="stock"]');
    var out = el && el.querySelector('[data-wl-deliv-date]');
    if (!out || !window.Intl || !Intl.DateTimeFormat) return;
    var days = parseInt(el.getAttribute('data-days'), 10) || 3;
    var sat = el.getAttribute('data-sat') === '1';
    var off = (el.getAttribute('data-off') || '').match(/\d{4}-\d{2}-\d{2}/g) || [];
    var d = deliveryDate(new Date(), days, sat, off);
    var lang = document.documentElement.getAttribute('lang') || 'fr';
    var txt;
    try { txt = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d); }
    catch (e) { txt = new Intl.DateTimeFormat('fr', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d); }
    out.textContent = txt;
    el.setAttribute('data-ready', '1');
  }

  /* Barre d'achat collante (une seule : section « Barre d'achat » du groupe Fiche produit).
     Le vrai bouton d'achat est dans le premier écran : la barre n'apparaît qu'une fois ce bouton sorti par le haut.
     « Choisir ma taille » ouvre la feuille de tailles ; la taille choisie est reportée sur le sélecteur du thème. */
  var touched = /[?&]variant=/.test(location.search);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.wl-pdp-main variant-selects')) touched = true;
  }, true);
  function sticky() {
    var bar = document.querySelector('[data-wl-sticky]');
    var btn = mainBtn();
    if (!bar || !btn) return;
    var price = document.querySelector('.wl-pdp-main [data-price-wrapper] [data-actual-price]');
    var p = bar.querySelector('[data-wl-sticky-price]');
    if (price && p) p.textContent = price.textContent.trim();
    var b = bar.querySelector('[data-wl-sticky-btn]');
    var choose = bar.getAttribute('data-choose');
    var label = btn.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
    if (bar.getAttribute('data-multi') === '1' && !touched && choose && !btn.disabled) label = choose;
    if (b && label && b.textContent !== label) b.textContent = label;
    if (b) b.classList.toggle('is-off', !!btn.disabled);
    sheetSync();
  }

  /* Feuille de tailles */
  function sheet() { return document.querySelector('[data-wl-sheet]'); }
  function variants() {
    var el = document.querySelector('.wl-pdp-main form.main-product-form script[data-name="main-product"]');
    try { return JSON.parse(el ? el.textContent : '[]'); } catch (e) { return []; }
  }
  function optInputs(n) {
    return document.querySelectorAll('.wl-pdp-main variant-selects [data-option-index="option' + n + '"] input[type="radio"]');
  }
  function chosen() {
    var out = [];
    for (var n = 1; n <= 3; n++) {
      var list = optInputs(n), v = null;
      if (!list.length) break;
      list.forEach(function (i) { if (i.checked) v = i.value; });
      out.push(v);
    }
    return out;
  }
  function findVariant(size) {
    var sh = sheet(); if (!sh) return null;
    var idx = parseInt(sh.getAttribute('data-opt'), 10) - 1;
    var cur = chosen(); cur[idx] = size;
    var vs = variants();
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var k = 0; k < cur.length; k++) if (cur[k] != null && vs[i].options[k] !== cur[k]) ok = false;
      if (ok) return vs[i];
    }
    return null;
  }
  var picked = null;
  function sheetSync() {
    var sh = sheet(); if (!sh) return;
    var add = sh.querySelector('[data-wl-sheet-add]');
    sh.querySelectorAll('[data-wl-size]').forEach(function (b) {
      var v = findVariant(b.getAttribute('data-wl-size'));
      b.classList.toggle('is-out', !v || !v.available);
      b.setAttribute('aria-pressed', picked === b.getAttribute('data-wl-size') ? 'true' : 'false');
    });
    if (!add) return;
    if (!add.getAttribute('data-hint')) add.setAttribute('data-hint', add.textContent);
    var pv = picked != null ? findVariant(picked) : null;
    add.disabled = !pv || !pv.available;
    add.textContent = !pv ? add.getAttribute('data-hint') : pv.available ? sh.getAttribute('data-add') : sh.getAttribute('data-soldout');
  }
  var sheetLast = null;
  function openSheet() {
    var sh = sheet(); if (!sh) return false;
    sheetLast = document.activeElement;
    if (touched) {
      var sel = chosen()[parseInt(sh.getAttribute('data-opt'), 10) - 1];
      if (sel != null) picked = sel;
    }
    sheetSync();
    sh.hidden = false;
    document.documentElement.classList.add('wl-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { sh.classList.add('is-open'); }); });
    var f = sh.querySelector('[aria-pressed="true"]') || sh.querySelector('.wl-sheet__panel');
    if (f) f.focus({ preventScroll: true });
    return true;
  }
  function closeSheet() {
    var sh = sheet(); if (!sh || sh.hidden) return;
    sh.classList.remove('is-open');
    if (!document.querySelector('.wl-sgd.is-open')) document.documentElement.classList.remove('wl-lock');
    setTimeout(function () { if (!sh.classList.contains('is-open')) sh.hidden = true; }, 320);
    if (sheetLast && sheetLast.focus) sheetLast.focus({ preventScroll: true });
  }
  function pickSize(size) {
    var sh = sheet(); if (!sh) return;
    picked = size; touched = true;
    var n = sh.getAttribute('data-opt');
    optInputs(n).forEach(function (i) {
      if (i.value === size && !i.checked) { i.click(); }
    });
    sheetSync();
  }
  function addFromSheet() {
    var v = picked != null ? findVariant(picked) : null;
    if (!v || !v.available) return;
    var add = sheet().querySelector('[data-wl-sheet-add]');
    if (add) add.classList.add('is-busy');
    var t0 = Date.now();
    (function wait() {
      var f = document.querySelector('.wl-pdp-main form.main-product-form [name="id"]');
      var btn = mainBtn();
      if (f && btn && String(f.value) === String(v.id) && !btn.disabled) {
        if (add) add.classList.remove('is-busy');
        closeSheet();
        btn.click();
      } else if (Date.now() - t0 < 2500) {
        setTimeout(wait, 60);
      } else if (add) { add.classList.remove('is-busy'); }
    })();
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var s = t.closest('[data-wl-size]');
    if (s) { pickSize(s.getAttribute('data-wl-size')); return; }
    if (t.closest('[data-wl-sheet-add]')) { addFromSheet(); return; }
    if (t.closest('[data-wl-sheet-close]')) { e.preventDefault(); closeSheet(); return; }
    var b = t.closest('[data-wl-sticky-btn]');
    if (!b) return;
    var bar = b.closest('[data-wl-sticky]');
    var btn = mainBtn();
    if (!btn) return;
    var multi = bar.getAttribute('data-multi') === '1';
    if (multi && (!touched || btn.disabled) && openSheet()) return;
    var pick = document.querySelector('.wl-pdp-main .product-option-selector-box');
    if (btn.disabled || (multi && !touched && pick)) {
      var target = pick || btn;
      var y = target.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: y, behavior: 'smooth' });
      target.classList.remove('wl-flash'); void target.offsetWidth; target.classList.add('wl-flash');
    } else {
      btn.click();
    }
  });
  document.addEventListener('keydown', function (e) {
    var sh = sheet();
    if (!sh || sh.hidden) return;
    if (e.key === 'Escape') { closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(sh.querySelectorAll('button:not([disabled]),a[href]'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && (document.activeElement === f[0] || !sh.contains(document.activeElement))) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  var io = null, ioTarget = null;
  function watchSticky() {
    var bar = document.querySelector('[data-wl-sticky]');
    var btn = mainBtn();
    if (!bar || !btn) return;
    if (!window.IntersectionObserver) { bar.classList.add('is-on'); return; }
    var target = btn.closest('.checkout-btn') || btn.closest('form') || btn;
    if (target === ioTarget) return;
    if (io) io.disconnect();
    ioTarget = target;
    io = new IntersectionObserver(function (en) {
      var r = en[0];
      /* Barre visible seulement quand le vrai bouton est passé au-dessus de l'écran (après défilement), téléphone comme ordinateur */
      var on = !r.isIntersecting && r.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.classList.toggle('is-hid', !on);
      document.documentElement.classList.toggle('wl-sticky-on', on);
    });
    io.observe(target);
  }

  /* Quantité (− 1 +) : plafond = stock de la variante choisie (produits qui ne se vendent pas en rupture),
     boutons grisés aux limites. Les boutons du thème sont respectés : on n'agit que s'ils n'ont rien changé. */
  function qtyInput() { return document.querySelector('.wl-pdp-main form.main-product-form [data-wl-qty]'); }
  function qtyMax() {
    var el = document.querySelector('.wl-pdp-main [data-wl-qty-max]'), map = {};
    try { map = JSON.parse(el ? el.textContent : '{}'); } catch (e) { map = {}; }
    return parseInt(map[variantId()], 10) || 0;
  }
  function qtySync() {
    var inp = qtyInput();
    if (!inp) return;
    var m = qtyMax();
    if (m > 0) inp.setAttribute('max', m); else if (!inp.hasAttribute('data-max')) inp.removeAttribute('max');
    var min = parseInt(inp.getAttribute('min'), 10) || 1;
    var max = parseInt(inp.getAttribute('max'), 10) || 0;
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < min) v = min;
    if (max && v > max) v = max;
    if (String(v) !== inp.value) inp.value = v;
    var box = inp.closest('[data-quantity-wrapper]') || inp.parentNode;
    var dn = box.querySelector('[data-quantity-decrement]'), up = box.querySelector('[data-quantity-increment]');
    if (dn) dn.disabled = v <= min;
    if (up) up.disabled = !!max && v >= max;
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.wl-pdp-main [data-quantity-increment], .wl-pdp-main [data-quantity-decrement]') : null;
    if (!b) return;
    var box = b.closest('[data-quantity-wrapper]');
    var inp = box && box.querySelector('[data-wl-qty]');
    if (!inp) return;
    var before = inp.value;
    var step = parseInt(inp.getAttribute('step'), 10) || 1;
    var dir = b.hasAttribute('data-quantity-increment') ? 1 : -1;
    setTimeout(function () {
      if (inp.value === before) inp.value = (parseInt(before, 10) || 1) + dir * step;
      qtySync();
    }, 0);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-wl-qty')) qtySync();
  });

  /* Description courte : 2 lignes sur téléphone, « Lire plus » seulement si le texte est coupé */
  function shortText() {
    var lab = document.querySelector('[data-wl-buybar]');
    document.querySelectorAll('[data-wl-short]').forEach(function (box) {
      var t = box.querySelector('.wl-pdp-short__t'), b = box.querySelector('.wl-pdp-short__more');
      if (t && !b && lab && lab.getAttribute('data-more')) {
        /* Libellés réglés dans la section « Barre d'achat » (groupe Fiche produit Waïloa) */
        b = document.createElement('button');
        b.type = 'button'; b.className = 'wl-pdp-short__more'; b.hidden = true;
        b.setAttribute('aria-expanded', 'false');
        if (t.id) b.setAttribute('aria-controls', t.id);
        b.setAttribute('data-more', lab.getAttribute('data-more'));
        b.setAttribute('data-less', lab.getAttribute('data-less') || lab.getAttribute('data-more'));
        b.textContent = lab.getAttribute('data-more');
        box.appendChild(b);
      }
      if (!t || !b) return;
      if (!b.getAttribute('data-bound')) {
        b.setAttribute('data-bound', '1');
        b.addEventListener('click', function () {
          var open = !box.classList.contains('is-open');
          box.classList.toggle('is-open', open);
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
        });
      }
      if (box.classList.contains('is-open')) { b.hidden = false; return; }
      b.hidden = !(t.scrollHeight > t.clientHeight + 2);
    });
  }

  /* Apparition douce des grandes sections sous le pli */
  function reveal() {
    if (!window.IntersectionObserver) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = '.wl-imm__p, .wl-pdp-look, .related-products-section, .wl-pdp-reviews, .wl-pdp-faq, .wl-pdp-links, .wl-story';
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    document.documentElement.classList.add('wl-rv');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      el.classList.add('wl-reveal');
      if (r.top < window.innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
  }

  function init() {
    delivery();
    stock();
    sticky();
    watchSticky();
    shortText();
    qtySync();
    window.addEventListener('resize', shortText);
    reveal();
    var root = document.querySelector('.wl-pdp-main');
    if (root && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; stock(); sticky(); shortText(); watchSticky(); qtySync(); });
      }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      root.addEventListener('change', function () { window.setTimeout(stock, 60); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();